import React from 'react';

interface ProcessingStatusProps {
  message?: string;
}

export default function ProcessingStatus({
  message = "Completing your login..."
}: ProcessingStatusProps) {
  return (
    <div>
      <i
        className="fa fa-spinner fa-spin"
        style={{ fontSize: '2rem', marginBottom: '1rem', color: '#007bff' }}
      />
      <h2 style={{ marginBottom: '1rem' }}>{message}</h2>
      <p style={{ color: '#666' }}>
        We're securely processing your authentication. This should only take a moment.
      </p>
    </div>
  );
}